import React, { FC } from 'react';
import classnames from 'classnames';
import { Button as Btn, makeStyles, ButtonProps as BtnProps } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import ConfirmationIcon from '../../icons/confirmation-icon';

interface ButtonProps extends BtnProps {
  icon?: React.ReactNode;
  isDisabled?: boolean;
  isNav?: boolean;
  isSuccess?: boolean;
  isLoading?: boolean;
  target?: '_blank' | '_self' | '_parent' | '_top' | 'framename';
  rel?: string;
  labelColor?: string;
}

const styles = makeStyles(({ palette }: any) => ({
  success: {
    '&:hover.Mui-disabled': {
      backgroundColor: `${palette.success.dark} !important`,
    },
    '&:disabled': {
      backgroundColor: palette.success.dark,
      '& .MuiButton-label': {
        color: palette.text.contrastText,
        opacity: 1,
      },
    },
  },
  spinner: {
    opacity: 0.3,
    color: palette.common.white,
  },
}));

const Button: FC<ButtonProps> = ({
  children,
  icon,
  isDisabled,
  isNav,
  isSuccess,
  isLoading,
  className = '',
  type = 'button',
  onClick,
  ...props
}) => {
  const classes = styles({ isSuccess });
  const buttonClass = classnames({
    [classes.success]: isSuccess,
  });

  const startIcon = () => {
    if (isSuccess) {
      return <ConfirmationIcon size="small" transparentFill />;
    }
    if (isLoading) {
      return (
        <CircularProgress
          className={classes.spinner}
          aria-label="processing button press"
          size="1rem"
        />
      );
    }
    return icon;
  };

  return (
    <Btn
      variant="contained"
      disableElevation
      disabled={isLoading || isSuccess || isDisabled}
      className={`${className} ${buttonClass}`}
      startIcon={startIcon()}
      type={type}
      onClick={onClick}
      {...props}
    >
      {children}
    </Btn>
  );
};

Button.defaultProps = {
  icon: null,
  isDisabled: false,
  isSuccess: false,
  isLoading: false,
  isNav: true,
  target: undefined,
  rel: undefined,
  labelColor: undefined,
};

export default Button;
